"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = [{
  name: 'startDate',
  label: 'Session Start Date',
  initialValue: (0, _moment["default"])(new Date()).subtract(1, 'y').format('YYYY-MM-DD'),
  isRequired: true
}, {
  name: 'endDate',
  label: 'Session End Date',
  initialValue: (0, _moment["default"])(new Date()).format('YYYY-MM-DD'),
  isRequired: true
}, {
  name: 'groupIds',
  initialValue: [],
  label: 'Group Select'
}]; // Example of how to add custom filter field:
// {
//     name: 'middleDate',
//     label: 'Middle Date',
//     component: () => (
//         <Field name="middleDate" component={CccisdDatepicker} label="Middle Date" />
//     ),
// },